import { CalendarRepeatInterval } from "./calendar-repeat-interval";

export class VenueSetupCalendarEntry {
  constructor(venueDetailsId, venueSetupId) {
    this.id = undefined;
    this.venueSetupCalendarEntryId = { id: this.id };
    this.venueDetailsId = venueDetailsId;
    this.venueSetupId = venueSetupId;
    this.isActive = false;
    this.fromTime = undefined;
    this.fromDate = undefined;
    this.toTime = undefined;
    this.toDate = undefined;
    this.dates = [];
    this.inActiveDates = [];
    this.priority = 0;
    this.deleted = undefined;
    this.calendarRepeatInterval = undefined;
    this.type = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let venueSetupCalendarEntry =  Object.assign(new VenueSetupCalendarEntry(), json);

    if(venueSetupCalendarEntry.calendarRepeatInterval) {
      venueSetupCalendarEntry.calendarRepeatInterval =
        CalendarRepeatInterval.fromJSON(venueSetupCalendarEntry.calendarRepeatInterval);
    }

    return venueSetupCalendarEntry;
  }
}
